import React from 'react';
export function Testimonial() {
  return <section aria-label="Témoignage" className="mx-auto max-w-5xl px-6 py-24 text-center lg:px-10 lg:py-32" data-id="element-81" data-mp="1ftr12z1rvmqh">
      <figure data-id="element-82" data-mp="2kw7ztte8a7wa">
        <blockquote className="font-display text-3xl font-normal italic leading-snug text-ink md:text-[2.75rem] md:leading-[1.2]" data-id="element-83" data-mp="2658tyq4s1xge">
          « Après des années de douleurs à l’épaule, j’ai compris que je pouvais jouer autrement.
          Aujourd’hui, je prépare mes concerts sereinement — et le son a changé. »
        </blockquote>
        <figcaption className="mt-10 text-sm text-ink-soft" data-id="element-84" data-mp="33t96dinfkg2c">
          <span className="font-medium text-ink" data-id="element-85" data-mp="33qmw3b95nmgf">Camille R.</span> — violoncelliste d’orchestre
        </figcaption>
      </figure>
    </section>;
}